import { Tenant } from '../../../core/services/tenant'
import logo from '../../../assets/logo/logo.svg'

export async function fetchLogo(): Promise<string>{

const tenant = new Tenant()
    return fetch(`${tenant.getAPIBaseURL()}/api/desktops/logo?get_url=true&s=${tenant.subdomain}`, {
        credentials: 'include',
        headers: {
            "Content-Type": "Application/json"
        }
    })
    .then( res => res.json() )
    .then( res => res.data.logo_url )
    .catch( () => logo)
    
}